import { Button, Box, Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { userAuthInfoSelector } from '@app/domain/app';
import { useDeviceType } from '@app/hooks/useBrowserHooks';
import { imageAssets } from '@app/theme';

export function HomeCarousel(): ReactElement {
  const navigate = useNavigate();
  const { isDesktop } = useDeviceType();
  const authInfo = useRecoilValue(userAuthInfoSelector);
  return (
    <Box display={isDesktop ? 'grid' : 'block'}>
      <Box
        gridColumn={isDesktop ? '1 / -1' : 'auto'}
        gridRow={isDesktop ? '1 / -1' : 'auto'}
      >
        <img
          src={isDesktop ? imageAssets.homeTopDesktop : imageAssets.homeTop}
          width="100%"
          alt="プロフェッショナリズムに見合う仕事と報酬を"
        />
      </Box>
      <Box
        width={isDesktop ? 0.5 : 1}
        gridColumn={isDesktop ? '1 / -1' : 'auto'}
        gridRow={isDesktop ? '1 / -1' : 'auto'}
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          my: 1,
        }}
      >
        <Stack direction="column" width={isDesktop ? 'auto' : 1} sx={{ mx: 2 }}>
          {isDesktop && (
            <Typography
              variant="subtitle2"
              component="div"
              textAlign="left"
              fontSize="2rem"
              sx={{ mb: 2 }}
            >
              <div>プロフェッショナリズムに</div>
              <div>見合う仕事と報酬を</div>
            </Typography>
          )}
          {!authInfo && (
            <Button
              color="primary"
              variant="contained"
              fullWidth
              onClick={() => navigate('/register')}
              sx={{ height: 32, minHeight: 32 }}
            >
              無料で会員登録をする
            </Button>
          )}
        </Stack>
      </Box>
    </Box>
  );
}
